module.exports = __webpack_public_path__ + "img/needle.f641d0e7.svg";